import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import CustomDialog from "../../../components/Dialog/DiaComp";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import WrapTextOutlinedIcon from '@mui/icons-material/WrapTextOutlined';
import { DrugtypeTableData } from "./Drugs/SectionDiplo/GetDrugtypes";


export default function DiaType() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
    <Grid container >
        <Tooltip title="PGx Diplotypes" placement="bottom">
            <IconButton onClick={handleOpen} >
                <WrapTextOutlinedIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
            </IconButton>   
        </Tooltip>
    </Grid>

    <CustomDialog open={open} onClose={handleClose}

          title="PGx Genes - Diplotypes"
          content = {  <DrugtypeTableData /> }

        />
        
</>
)}